import { assertEx } from '@xylabs/sdk-js'
import { ButtonEx, ButtonExProps, FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'

import Identicon from './Identicon'
import QuadkeyMap from './QuadkeyMap'
import { useNavigateToQuadkey } from './useNavigateToQuadkey'

interface MapIconProps {
  crop?: boolean
  quadkey?: Quadkey
  size?: number
  world?: boolean
}

const MapIcon: React.FC<MapIconProps> = (props) => {
  const { quadkey, world = true, crop = true, size = 32 } = props
  if (quadkey) {
    return (
      <FlexRow>
        {world ? <QuadkeyMap quadkey={quadkey} size={size} /> : null}
        {crop ? <QuadkeyMap crop quadkey={quadkey} size={size} /> : null}
      </FlexRow>
    )
  } else {
    return null
  }
}

interface IdentificationProps extends ButtonExProps {
  cropMap?: boolean
  icon?: boolean
  iconSize?: number
  onClick?: (event: React.MouseEvent) => void
  page?: string
  quadkey?: Quadkey
  text?: boolean
  textColor?: string
  to?: string
  worldMap?: boolean
}

const GeotokenIdentification: React.FC<IdentificationProps> = ({
  quadkey,
  textColor = '#fff',
  iconSize = 32,
  icon = true,
  onClick,
  to,
  page = 'geotoken',
  worldMap = true,
  cropMap = true,
  text = true,
  ...props
}) => {
  const base4HashLabel = quadkey?.toBase4HashLabel()
  const { navigateToQuadkey } = useNavigateToQuadkey()

  const onClickLocal = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (onClick) {
      onClick(event)
    } else {
      navigateToQuadkey(assertEx(quadkey), event, page, to)
    }
  }

  return quadkey ? (
    <ButtonEx onClick={onClickLocal} variant="outlined" {...props}>
      {icon ? (
        <FlexRow alignItems="center" display="flex" justifyItems="center" marginRight={text ? 0.5 : 0}>
          {worldMap || cropMap ? (
            <MapIcon crop={cropMap} quadkey={quadkey} size={iconSize} world={worldMap} />
          ) : (
            <FlexRow display="flex">
              <Identicon size={iconSize} value={base4HashLabel} />
            </FlexRow>
          )}
        </FlexRow>
      ) : null}
      {text ? (
        <FlexRow alignItems="center" color={textColor} display="flex" justifyContent="center" marginX={1} minHeight={iconSize}>
          {`#${base4HashLabel}`}
        </FlexRow>
      ) : null}
    </ButtonEx>
  ) : null
}

export default GeotokenIdentification
